import React, { useEffect } from 'react'

import { HelpCenter } from '@/features/help-center'
import { Layout } from '@/components'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { NextSeo } from 'next-seo'

const HelpCenterIndexPage: React.FC<
  InferGetStaticPropsType<typeof getStaticProps>
> = (props) => {
  const router = useRouter()
  const { open_chat } = router.query

  useEffect(() => {
    // TODO: Kustomer.addListener('onClose', fn) where fn removes open_chat from the router
    if (typeof window === 'undefined') {
      return
    }
    if (open_chat) {
      ;(window as any)?.Kustomer?.open()
    }
  }, [open_chat])

  return (
    <>
      <Layout showLiveChatWidget>
        <div className={'page-wrapper'}>
          <HelpCenter />
        </div>
      </Layout>
      <NextSeo title={'HELP CENTER'} />
    </>
  )
}

export const getStaticProps = async ({
  locale,
  locales,
  preview,
}: GetStaticPropsContext<{ article: string }>) => {
  return {
    props: {},
  }
}

export default HelpCenterIndexPage
